import React from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'material-ui/AutoComplete';
import FieldTitle from 'components/aor/FieldTitle';
import IconButton from 'material-ui/IconButton';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { ClearIcon } from 'assets/materialIcons/materialIcons';

class RenderNullableAutoCompleteInputField extends React.Component {
    constructor(props) {
        super(props);

        const nullableObject = [
            {
                id: '',
                name: '',
            },
        ];

        const combinedChoices = [
            ...nullableObject,
            ...props.choices,
        ];

        this.state = {
            results: combinedChoices,
        };
    }

    clearData = () => {
        this.props.input.onChange('');
    }

    handleNewRequest = (chosenRequest, index) => {
        if (chosenRequest === '') {
            this.clearData();
        }

        if (index !== -1) {
            const { input, optionValue } = this.props;
            const { results } = this.state;

            input.onChange(results[index][optionValue]);
        }
    }

    getSuggestion(choice) {
        const { optionText, translate, translateChoice } = this.props;
        const choiceName = utils.isFunction(optionText) ? optionText(choice) : choice[optionText];

        return translateChoice ? translate(choiceName, { _: choiceName }) : choiceName;
    }

    render() {
        const {
            elStyle,
            filter,
            input,
            isRequired,
            label,
            meta: { touched, error },
            options,
            optionValue,
            resource,
            setFilter,
            source,
        } = this.props;

        const { results } = this.state;

        const selectedSource = results.find((choice) => {
            return choice[optionValue] === input.value;
        });

        const dataSource = results.map((choice) => {
            return {
                value: choice[optionValue],
                text: this.getSuggestion(choice),
            };
        });

        return (
            <div style={ { display: 'flex', alignItems: 'baseline', position: 'relative' } }>
                <AutoComplete
                    searchText={ selectedSource && this.getSuggestion(selectedSource) }
                    dataSource={ dataSource }
                    floatingLabelText={ <FieldTitle label={ label } source={ source } resource={ resource } isRequired={ isRequired } /> }
                    filter={ filter }
                    onNewRequest={ this.handleNewRequest }
                    onUpdateInput={ setFilter }
                    openOnFocus
                    style={ elStyle }
                    errorText={ touched && error }
                    { ...options }
                />

                <IconButton
                    onTouchTap={ this.clearData }
                    tooltip='Clear Data'
                    tooltipPosition='top-right'
                    style={ {
                        position: 'absolute',
                        bottom: '0',
                        right: '0',
                        padding: '12px 0px 12px 12px',
                    } }
                >
                    <ClearIcon color='grey' hoverColor='black'/>
                </IconButton>
            </div>
        );
    }
}

RenderNullableAutoCompleteInputField.defaultProps = {
    choices: [],
    filter: AutoComplete.fuzzyFilter,
    options: {},
    optionText: 'name',
    optionValue: 'id',
    translateChoice: true,
};

RenderNullableAutoCompleteInputField.propTypes = {
    choices: PropTypes.arrayOf(PropTypes.object),
    elStyle: PropTypes.object,
    filter: PropTypes.func.isRequired,
    input: PropTypes.object,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    meta: PropTypes.object,
    options: PropTypes.object,
    optionElement: PropTypes.element,
    optionText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]).isRequired,
    optionValue: PropTypes.string.isRequired,
    resource: PropTypes.string,
    setFilter: PropTypes.func,
    source: PropTypes.string,
    translate: PropTypes.func.isRequired,
    translateChoice: PropTypes.bool.isRequired,
};

export default translate(RenderNullableAutoCompleteInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderNullableAutoCompleteInputField.js